import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["select", "tos"];

  redirect(event) {
    event.preventDefault();
    const url = this.selectTarget.value;
    if (!url) return;
    if (this.hasTosTarget && !this.tosTarget.checked) return;
    window.location.href = url;
  }
}
